<div class="widget widget-datepicker">
    <input
        #dateElement
        readonly
        type="text"
        (ngModelChange)="onDateChange($event)"
        [required]="required ? true : false"
        [name]="name"
        [disabled]="disabled"
        [placeholder]="placeholder"
        [matDatepicker]="datepicker"
        [min]="min"
        [max]="max"
        [(ngModel)]="date"
        (mousedown)="datepicker.open()">

    <a *ngIf="resetable && date" class="widget-clear" (click)="onClearClick()"><i class="i i-cross-circle"></i></a>
    <i class="widget-icon i i-calendar"></i>
    <mat-datepicker #datepicker></mat-datepicker>
</div>
